import { fromJS } from 'immutable'
import {
  REPORT_ACTIVE_USERS_GET_REQUEST,
  REPORT_ACTIVE_USERS_GET_SUCCESS,
  REPORT_ACTIVE_USERS_GET_FAILURE,
  REPORT_ACTIVE_USERS_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case REPORT_ACTIVE_USERS_GET_REQUEST:
      return state
        .set('isFetching', true)
    case REPORT_ACTIVE_USERS_GET_SUCCESS:
      return state
        .set('isFetching', false)
        .set('activeUserReport', fromJS(action.payload.activeUserReport))
        .set('meta', fromJS(action.payload.meta))
    case REPORT_ACTIVE_USERS_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case REPORT_ACTIVE_USERS_GET_RESET:
      return state
        .delete('activeUserReport')
        .delete('meta')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/report/report-active-users-get-reducer.js